var map = {
	"./btn_breast_on.svg": "9f6e",
	"./btn_colorectal_on.svg": "de38",
	"./btn_dementia_on.svg": "ed95",
	"./btn_dm_on.svg": "dbe9",
	"./btn_heart_on.svg": "a5e3",
	"./btn_liver_on.svg": "ef4c",
	"./btn_lung_on.svg": "bf3b",
	"./btn_prostate_on.svg": "179c",
	"./btn_stomach_on.svg": "0b6b",
	"./btn_stroke_on.svg": "bb8c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a43";